// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable func-names, new-cap, babel/new-cap */
import immutable, { Map, Set } from "immutable"

import SearchFormState from "../records/SearchFormState"
import Place from "../records/Place"
import { optionsFromPlainJS } from "../records/Options"
import { getWindowType, getWidth } from "../../../app/scripts/tools/windowBindings"

export default function (input) {
  const state = {}

  const KEEP_PLAIN = [
    "params",
    "router",
    "currencies",
    "query",
    "translations",
    "staticData",
    "remoteConfig",
    "confirmedForms",
    "resultsView",
    "searchFiltersForm",
    "placesRequests",
    "splitster",
    "sideNav",
    "reservation",
    "topRoutes",
    "simpleLandingPageData",
  ]

  Object.keys(input).forEach((key) => {
    if (key === "searchForm" && input.searchForm) {
      state[key] = SearchFormState.fromPlainJS(input[key])
    } else if (KEEP_PLAIN.includes(key)) {
      // do not convert to immutable if it is not changing on client
      state[key] = input[key]
    } else if (key === "places") {
      if (input[key].places) {
        const { places } = input[key]
        let placesMap = Map()
        Object.keys(places).forEach((placeKey) => {
          placesMap = placesMap.set(placeKey, Place.fromPlainJS(places[placeKey]))
        })
        state[key] = Map({
          places: placesMap,
          loading: false,
          error: false,
          loadingIds: Set(),
          errorIds: Set(),
        })
      }
    } else if (key === "options") {
      state[key] = optionsFromPlainJS(input[key])
    } else {
      // by default convert to container/model object
      state[key] = immutable.fromJS(input[key])
    }
    state.window = { type: getWindowType(), width: getWidth() }
    return null
  })
  return state
}
